import { styled } from '@mui/material/styles';
import { Box, Paper, Tabs, Tab } from '@mui/material';

export const MainContentWrapper = styled(Box)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(1),
  backgroundColor: '#1e1e1e',
  height: '100%',
}));

export const StyledTabs = styled(Tabs)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  minHeight: '42px',
  '& .MuiTabs-indicator': {
    backgroundColor: '#fff',
    transition: 'transform 0.3s ease-in-out, left 0.3s ease-in-out, width 0.3s ease-in-out',
  },
}));

export const StyledTab = styled(Tab)(({ theme }) => ({
  color: 'rgba(255, 255, 255, 0.7)',
  backgroundColor: '#252526',
  transition: 'all 0.2s ease',
  '&.Mui-selected': {
    color: '#fff',
    backgroundColor: '#2d2d2d',
    fontWeight: 500,
    boxShadow: '0 0 0 1px rgba(255, 255, 255, 0.1)',
  },
  '&:hover': {
    color: '#fff',
    opacity: 1,
    backgroundColor: '#2a2a2a',
  },
  '&.Mui-disabled': {
    color: 'rgba(255, 255, 255, 0.3)',
    backgroundColor: '#1a1a1a',
  },
  minWidth: '120px',
  minHeight: '42px',
  borderRadius: '8px 8px 0 0',
  padding: '0 16px',
  marginRight: '2px',
}));

export const TabPanel = styled(Paper)(({ theme }) => ({
  backgroundColor: '#252526',
  borderRadius: theme.spacing(1),
  padding: theme.spacing(1.5),
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
  boxShadow: '0 1px 4px rgba(0, 0, 0, 0.2)',
  overflow: 'hidden',
}));

export const ServiceSection = styled(Box)(({ theme }) => ({
  backgroundColor: '#1e1e1e',
  borderRadius: theme.spacing(1),
  padding: theme.spacing(1.5),
}));

export const DetailsSection = styled(Box)(({ theme }) => ({
  backgroundColor: '#1e1e1e',
  borderRadius: theme.spacing(1),
  padding: theme.spacing(1.5),
}));
